(() => {
  const dialog = document.getElementById('hf-region-dialog');
  if (!dialog || dialog.dataset.initialized === 'true') return;
  dialog.dataset.initialized = 'true';

  const grid = dialog.querySelector('[data-region-grid]');
  const countries = Array.from(dialog.querySelectorAll('[data-region-country]'));
  const tabs = Array.from(dialog.querySelectorAll('[data-region-tab]'));
  const panel = dialog.querySelector('#hf-region-panel');
  const search = dialog.querySelector('[data-region-search]');
  const empty = dialog.querySelector('[data-region-empty]');
  const emptyMessage = dialog.querySelector('[data-region-empty-message]');
  const status = dialog.querySelector('[data-region-status]');
  const regionCodes = {
    americas: 'AI AG AW BS BB BZ BM BQ BV CA KY CL CO CR CU CW DM DO EC SV FK GF GL GD GP GT GY HT HN JM MQ MX MS NI PA PY PE PR BL KN LC MF PM VC SX SR TT TC US UY VE VG VI AR BO BR',
    europe: 'AL AD AT AX BY BE BA BG HR CY CZ DK EE FO FI FR DE GI GR GG VA HU IS IE IM IT JE XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE CH TR UA GB',
    asia: 'AF AM AZ BH BD BT BN KH CN GE HK IN ID IR IQ IL JP JO KZ KW KG LA LB MO MY MV MN MM NP KP OM PK PS PH QA SA SG KR LK SY TW TJ TH TL TM AE UZ VN YE',
    africa: 'DZ AO BJ BW BF BI CV CM CF TD KM CG CD CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU YT MA MZ NA NE NG RE RW SH ST SN SC SL SO ZA SS SD TZ TG TN UG EH ZM ZW',
    oceania: 'AS AU CX CC CK FJ PF GU HM KI MH FM NR NC NZ NU NF MP PW PG PN WS SB TK TO TV UM VU WF'
  };
  const continentFor = new Map();
  Object.entries(regionCodes).forEach(([region, codes]) => codes.split(' ').forEach(code => continentFor.set(code, region)));
  let displayNames;
  try { displayNames = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (_) { /* The Liquid country name remains a usable fallback. */ }
  document.querySelectorAll('[data-country-label]').forEach(label => {
    const code = label.dataset.countryLabel;
    if (displayNames && /^[A-Z]{2}$/.test(code)) label.textContent = displayNames.of(code) || label.textContent;
  });
  countries.forEach(country => {
    country.dataset.continent = continentFor.get(country.dataset.regionCountry) || 'other';
    country.dataset.searchName = country.querySelector('.hf-country-name').textContent.toLocaleLowerCase('en');
  });
  countries.sort((a, b) => a.dataset.searchName.localeCompare(b.dataset.searchName, 'en'));
  countries.forEach(country => grid.appendChild(country));

  let activeRegion = 'all';
  let opener = null;
  const updateResults = () => {
    const term = search.value.trim().toLocaleLowerCase('en');
    let count = 0;
    countries.forEach(country => {
      const matchesRegion = activeRegion === 'all' || country.dataset.continent === activeRegion;
      const matchesSearch = !term || country.dataset.searchName.includes(term) || country.dataset.regionCountry.toLowerCase().includes(term);
      country.hidden = !(matchesRegion && matchesSearch);
      if (!country.hidden) count += 1;
    });
    empty.hidden = count > 0;
    emptyMessage.textContent = term ? 'No matching countries or regions.' : 'More regions are coming.';
    status.textContent = `${count} ${count === 1 ? 'country or region' : 'countries and regions'} available.`;
  };
  const selectTab = (tab, focus = false) => {
    activeRegion = tab.dataset.regionTab;
    tabs.forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    panel.setAttribute('aria-labelledby', tab.id);
    updateResults();
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', event => {
      let nextIndex;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === undefined) return;
      event.preventDefault();
      selectTab(tabs[nextIndex], true);
    });
  });
  search.addEventListener('input', updateResults);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-region-open]');
    if (!trigger || dialog.open) return;
    opener = trigger;
    search.value = '';
    selectTab(tabs[0]);
    dialog.showModal();
    document.documentElement.classList.add('hf-region-is-open');
    trigger.setAttribute('aria-expanded', 'true');
    dialog.querySelector('[data-region-close]').focus();
  });
  dialog.querySelector('[data-region-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('hf-region-is-open');
    document.querySelectorAll('[data-region-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus();
  });
  updateResults();
})();
